import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatIDString",
  pure: false,
  standalone: false,
})
export class FormatIDDisplay implements PipeTransform {
  transform(value: any): any {
    if (value) {
      if (typeof value === "string") {
        return value.toLowerCase().replaceAll(" ", "-").trim();
      }
      if (typeof value === "number") {
        return value.toString();
      }
    }
    return "";
  }
}
